export default "__VITE_ASSET__4_EVN$pH__"